import { BlogArticle } from "../components/pages/blogArticle";

export function BlogArticlePage(){

    return(
        <>
            <BlogArticle />
        </>
    );
}